import 'mathlive/dist/mathlive-fonts.css';
import 'mathlive/dist/mathlive-static.css';

import './RichTextRenderer.scss';

import * as React from 'react';

import { insertEmbed } from '../../../embedded';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  htmlText: string;
}

export const RichTextRenderer = ({ htmlText, ...props }: Props) => {
  const withEmbeddedHtml = React.useMemo(() => {
    return {
      __html: insertEmbed(htmlText),
    };
  }, [htmlText]);
  const className = `${props.className} rich-text`;

  return (
    <div
      dangerouslySetInnerHTML={withEmbeddedHtml}
      {...props}
      className={className}
    ></div>
  );
};
